import {
  AfterViewInit,
  Component,
  DoCheck,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { SessionService } from '@app/security/session.service';
import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { firstValueFrom, map } from 'rxjs';
import WirePreview from '../wire-preview-react/WirePreview';
import { Journey } from '@app/core/models/journey';
import { MessageClass } from '@app/core/models/message';
import { BrandingData } from '@relaynetwork/design-system';
import { ProductGroup } from '@app/core/models/client';
import { MediaService } from '@app/core/services/media.service';
import { MediaAsset } from '@relaynetwork/rn-node-feed-api-types';

let wirePreviewInstanceId = 0;

@Component({
  selector: 'wire-preview-react',
  templateUrl: './wire-preview-react-container.component.html',
  styleUrls: ['./wire-preview-react-container.component.scss'],
  standalone: true,
})
export class WirePreviewReactContainerComponent
  implements OnInit, AfterViewInit, OnDestroy, DoCheck, OnChanges
{
  constructor(
    private sessionService: SessionService,
    private mediaService: MediaService,
  ) {}

  reactWrapperId: string;
  clientId: string;
  fdic_enabled: boolean;
  oldMessage: string;
  @Input() message: MessageClass;
  @Input() components: Journey['live']['components'];
  @Input() brandingColor: string;
  @Input() disclaimerConfig: BrandingData['disclaimer'];
  @Input() productGroup: ProductGroup;
  @Input() previewMode: 'expanded' | 'collapsed';
  @Input() language?: string;
  @Input() showFeedViewDisclaimer?: boolean = false;

  root: Root = null;
  ngOnInit() {
    this.clientId = this.sessionService.getCurrentUsersClient().id;
    this.fdic_enabled = this.sessionService.getCurrentUsersClient().fdic_enabled;
    this.reactWrapperId = `${this.message.name}-wire-preview-${++wirePreviewInstanceId}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngOnDestroy(): void {
    this.root.unmount();
  }

  ngDoCheck() {
    if (JSON.stringify(this.message) !== this.oldMessage) {
      this.oldMessage = JSON.stringify(this.message);
      this.render();
    }
  }

  ngAfterViewInit(): void {
    const node = document.getElementById(this.reactWrapperId);
    this.root = createRoot(node);
    this.render();
  }

  getMediaAssetForMessage(assetId: string): Promise<MediaAsset> {
    return firstValueFrom(
      this.mediaService.getMediaAsset(assetId, true).pipe(
        map((response) => ({
          ...response,
          id: response.asset_id,
        })),
      ),
    ) as unknown as Promise<MediaAsset>;
  }

  protected render() {
    if (this.root) {
      this.root.render(
        React.createElement(WirePreview, {
          message: Object.assign({}, this.message),
          brandingColor: this.brandingColor,
          disclaimerConfig: this.disclaimerConfig,
          isDestinationMessageDetail:
            this.message.sms.auth_link === '@{auth-link}',
          previewMode: this.previewMode,
          components: this.components,
          productGroup: this.productGroup,
          clientId: this.clientId,
          getMediaAssetForMessage: this.getMediaAssetForMessage.bind(this),
          language: this.language,
          fdic_enabled: this.fdic_enabled,
          showFeedViewDisclaimer: this.showFeedViewDisclaimer,
        }),
      );
    }
  }
}
